<template>
  <div id="app" style="width: 1400px; margin-top: 10px;">
      <div class="d-flex flex-row">
          <div class="p" id="col-controlpanel" style="width:30%;padding-left: 3px; padding-right: 3px; text-align:center;">
            <UserFilter></UserFilter>
          </div>
          <div class="p" id="col-exploration" style="width:70%;padding-left: 3px; padding-right: 3px; text-align:center;">
              <ExplorationView :featureThs="featureThs"></ExplorationView>
          </div>
    </div>
  </div>
</template>

<script>

import UserFilter from "./components/UserFilter/UserFilter.vue"
import ExplorationView from "./components/ExplorationView/ExplorationView.vue"
import pipeService from './service/pipeService.js'

export default {
  name: 'app',
  components: {
    UserFilter,
    ExplorationView,
  },
  data() {
    return {
        toggleval: true,
        // --- feature thresholds
        featureThs: {
            "disconnection": 0.5,
            "repetition": 0.5,
            "polarity": 0.5,
            "subjectivity": 0.5,
            "volume": 1.1,
            "pitch": 1.1,
            "pause": 0.5,
            "speed": 1.5,
        },


    }
  },
  mounted: function () {
    //--- print window size
    console.log("window size:", screen.width+"*"+screen.height);
    const _this = this;
    pipeService.onFeatureThresholds(th => {
        console.log("--- receive thresholds: ---", th);
        this.$nextTick(() => {
          _this.featureThs = th;
        })
    });
  },
  methods: {
  }
}
</script>

<style>
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  margin: 0 auto;
}

.container {
  width: 100%;
  padding: 5px 5px 5px 5px;
}

.content {
  padding: 2px 2px 2px 2px;
}

footer {
  margin-left: 5px;
}

#controlpanelnav div {
  position: relative;
  right: 4px;
  top: 2px;
  transition: 0.3s;
  padding: 0px;
  width: 10px;
  height: 686px;
  vertical-align:-webkit-baseline-middle;
  font-size: 12px;
  border-radius: 0px 4px 4px 0px;
  background-color: #c8ced4;
  color: white;
}

#controlpanelnav div:hover, #detailnav div:hover {
  opacity: 0.6;
}

#controlpanel-left, #detailnav-left, #controlpanel-right, #detailnav-right {
  /* background-color: #c8ced4; */
  opacity: 0.3;
}

#detailnav div {
  position: relative;
  left:2px;
  top: 2px;
  transition: 0.3s;
  padding: 0px;
  width: 10px;
  height: 686px;
  /* text-decoration: none; */
  vertical-align:-webkit-baseline-middle;
  font-size: 12px;
  border-radius: 0px 4px 4px 0px;
  background-color: #c8ced4;
  color: white;
}


</style>
